import { Card, CardContent } from '@billda/design-system';
import { MailOutlineIcon } from '@billda/design-system';

interface UserInvitationCardProps {
  invitedByUserName: string;
  invitedAt: string;
  formatDateTime: (dateString: string) => string;
}

export function UserInvitationCard({
  invitedByUserName,
  invitedAt,
  formatDateTime,
}: UserInvitationCardProps) {
  return (
    <Card data-testid="user-invitation-card">
      <CardContent className="pt-4">
        <div className="flex flex-col gap-4">
          {/* Card Title */}
          <div className="flex items-center gap-2">
            <MailOutlineIcon
              aria-hidden="true"
              className="size-4 text-content-secondary"
            />
            <h3 className="type-h6">Invitation Details</h3>
          </div>

          {/* Invitation Details */}
          <div className="flex flex-col gap-2">
            {/* Invited By */}
            <div className="flex justify-between">
              <span className="type-body-md text-content-secondary">
                Invited By
              </span>
              <span className="type-body-md font-medium">
                {invitedByUserName}
              </span>
            </div>

            {/* Date & Time */}
            <div className="flex justify-between">
              <span className="type-body-md text-content-secondary">
                Date & Time
              </span>
              <span className="type-body-md font-medium">
                {formatDateTime(invitedAt)}
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
